import { h, FunctionalComponent } from 'preact';
import { onKeyboardSelection } from 'helpers/operators';
import './footer.scss';
import { useContext } from 'preact/hooks';
import { ApplicationContext } from 'services/use-application-setup';
import { useTranslation } from 'services/use-translation';
import { Logo } from './logo';
import { ShortpointLogo } from './shortpoint-logo';
import { PortcitymarketingLogo } from './portcitymarketing-logo';
import { GenericPartnerLogo } from './generic-partner-logo';
import { useFooter } from './use-footer';

const truncate = (text: string, limit: number) =>
  text.length > limit ? text.substr(0, limit - 1) : text;

export const Footer: FunctionalComponent = () => {
  const context = useContext(ApplicationContext);
  const { translate } = useTranslation();
  const {
    clickToMainMenu,
    clickBack,
    accessibilityStatementText,
    asteriskVisible,
    isPartnerDefaultLogoEnvironment,
    isGenericPartnerCustomLogoEnvironment,
    manageLinkVisible,
    reportProblemVisible,
    accessibilityStatementVisible,
    isFooterNavLinksVisible,
    isUserwayLogoHidden,
    goLogin,
    goReport,
    callbackRef,
    isMainMenuUrl,
    isLogged,
    backState,
    accessibilityStatementLink
  } = useFooter({ context, translate });

  const isCustomLogoEnvironment = isPartnerDefaultLogoEnvironment || isGenericPartnerCustomLogoEnvironment;
  
  return (
    <div
      ref={callbackRef}
      className={`uwaw-footer ${
        asteriskVisible ? 'uwaw-footer_has-asterisk' : ''
      } ${
        isCustomLogoEnvironment ? 'uwaw-footer_has-brand' : ''
      }  ${
        isFooterNavLinksVisible && accessibilityStatementVisible
          ? 'uwaw-footer_has-has-statement'
          : ''
      }`}
    >
      <div className="uwaw-footer__i">
        <div className="uwaw-footer__l">
          <ul className="uwaw-footer__nav">
            {isFooterNavLinksVisible && accessibilityStatementVisible && (
              <li className="uwaw-footer__nav__item">
                <a
                  className="uwaw-footer__nav__lnk"
                  href={accessibilityStatementLink}
                  target="_blank"
                  aria-label={` ${accessibilityStatementText} - opens in a new tab`}
                >
                  <span className="uwaw-features__nav_truncate">
                    {truncate(accessibilityStatementText, 50)}
                  </span>
                </a>
              </li>
            )}
            {isFooterNavLinksVisible && reportProblemVisible && (
              <li className="uwaw-footer__nav__item">
                <a
                  className="uwaw-footer__nav__lnk"
                  tabIndex={0}
                  onClick={goReport}
                  onKeyUp={onKeyboardSelection(goReport)}
                >
                  {translate('widget.footer.report.label')}
                </a>
              </li>
            )}
            {isFooterNavLinksVisible && manageLinkVisible && (
              <li className="uwaw-footer__nav__item">
                <a
                  className="uwaw-footer__nav__lnk uwaw-footer__nav__lnk_mng"
                  onClick={goLogin}
                  onKeyUp={onKeyboardSelection(goLogin)}
                  tabIndex={0}
                >
                  {translate('widget.footer.manage.label')}
                </a>
              </li>
            )}

            {isLogged && backState && (
              <li className="uwaw-footer__nav__item">
                <a
                  className="uwaw-footer__nav__lnk uwaw-footer__nav__lnk_mng"
                  onKeyUp={onKeyboardSelection(isMainMenuUrl ? clickToMainMenu : clickBack)}
                  onClick={isMainMenuUrl ? clickToMainMenu : clickBack}
                  tabIndex={0}
                >
                  {translate('widget.footer.misc.main_menu')}
                </a>
              </li>
            )}
          </ul>
        </div>
        {!isCustomLogoEnvironment && (<div className="uwaw-footer__r">{<Logo />}</div>)}

      </div>



      <ShortpointLogo />

      <PortcitymarketingLogo />

      {asteriskVisible && <a className="uwaw-footer__asterisk"
                             onClick={goLogin}
                             onKeyUp={onKeyboardSelection(goLogin)}
                             tabIndex={0} aria-label={translate(isUserwayLogoHidden ? 'widget.footer.manage_whitelabel.aria' : 'widget.footer.manage.aria')}>
        *
      </a>}

      <GenericPartnerLogo />
    </div>
  );
};
